function getPositionCoords(element) {
    var xCoords = 0;
    var yCoords = 0;

    while(element) {
        xCoords += (element.offsetLeft - element.scrollLeft + element.clientLeft);
        yCoords += (element.offsetTop - element.scrollTop + element.clientTop);
        element = element.offsetParent;
    }

    return { x: xCoords, y: yCoords };
}

export default {
    name: 'FilterPager',
    data(){
        return {
            maxPages: 6
        }
    },
    props: {
        receivesFocus: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed:{
        pageSize(){
            return this.pagingResponseData.take
        },
        pagingResponseData(){
            const searchConfigFromStore = this.$store.state.search.searchConfig
            return {
                skip: searchConfigFromStore.skip,
                take: searchConfigFromStore.take,
                total: searchConfigFromStore.totalHits
            }
        },
        currentlyViewingPage(){
            return Math.ceil((this.pagingResponseData.skip/this.pageSize)+1)
        },
        pagesAvailable(){
            return Math.ceil(this.pagingResponseData.total / this.pageSize)
        },
        maxPagesExceeded(){
            return this.pagesAvailable > this.maxPages
        },
        decrementPage(){
            let decrementer = null
            if(this.currentlyViewingPage > 1){
                const skipCount = (this.currentlyViewingPage-2)*this.pageSize
                decrementer = {
                    clickHandler: ()=>{
                        this.navigateToPage(skipCount)
                    }
                }
            }
            return decrementer
        },
        displayPager(){
            return (this.pagesAvailable > 1)
        },
        incrementPage(){
            let incrementer = null
            if(this.currentlyViewingPage < this.pagesAvailable){
                const skipCount = (this.currentlyViewingPage)*this.pageSize
                incrementer = {
                    clickHandler: ()=>{
                        this.navigateToPage(skipCount)
                    }
                }
            }
            return incrementer
        },
        pagerSteps(){
            const currentlyViewingPage = this.currentlyViewingPage
            const pagesAvailable = this.pagesAvailable

            let latePagersStartAt = pagesAvailable-1
            if((this.maxPagesExceeded && (this.pagesAvailable-5 <= this.currentlyViewingPage))){
                latePagersStartAt = pagesAvailable-4
            }

            let pagerSteps = []

            let before = 0
            let after = pagesAvailable <= 4 ? pagesAvailable-1 : 4

            const generatePagerItem = (pagerSteps) => {
                const startAt = currentlyViewingPage-before
                const endAt = currentlyViewingPage+after
                let counter = startAt

                while(counter <= endAt){
                    const skipCount = (this.pageSize*counter)-this.pageSize
                    pagerSteps.push({
                        type: 'page',
                        displayNumber: counter,
                        current: (currentlyViewingPage===counter),
                        clickHandler: ()=>{
                            this.navigateToPage(skipCount)
                        }
                    })
                    counter++
                }

                return pagerSteps
            }

            if(pagesAvailable < 4){
                let counter = 1
                let endAt = pagesAvailable

                while(counter <= endAt){
                    const skipCount = (this.pageSize*counter)-this.pageSize
                    pagerSteps.push({
                        type: 'page',
                        displayNumber: counter,
                        current: (currentlyViewingPage===counter),
                        clickHandler: ()=>{
                            this.navigateToPage(skipCount)
                        }
                    })
                    counter++
                }

            } else {
                if(currentlyViewingPage <= 2){
                    before = before+(currentlyViewingPage-1)
                    after = after-before
                    pagerSteps = generatePagerItem(pagerSteps)
                    
                }
    
                if(currentlyViewingPage > 2 && currentlyViewingPage < latePagersStartAt){
                    // center the current page
                    before = 2
                    after = 2
                    pagerSteps = generatePagerItem(pagerSteps)
                }
    
                if(currentlyViewingPage >= latePagersStartAt ){
                    // move current page towards right
                    let localBefore = pagesAvailable >= 4 ? 4-(pagesAvailable-currentlyViewingPage) : 4
                    localBefore = localBefore === 4 ? 3 : localBefore
                    const addFinalPagerSteps = (this.maxPagesExceeded && (this.pagesAvailable-5 <= this.currentlyViewingPage))
                    before = (addFinalPagerSteps ? 6 : localBefore)-(pagesAvailable-currentlyViewingPage)
                    after = pagesAvailable-currentlyViewingPage
    
                    pagerSteps = generatePagerItem(pagerSteps)
                }
            }

            return pagerSteps
        },
        pagerRenderData(){
            const finalPagersStartAt = this.pagesAvailable-1
            const pagerRenderData = this.pagerSteps
            const addFinalPagerSteps = (this.maxPagesExceeded && (this.pagesAvailable-5 >= this.currentlyViewingPage))

            if(addFinalPagerSteps){

                //inject splitter
                pagerRenderData.push({
                    type: 'split'
                })

                // inject required final pagers
                for(let counter = finalPagersStartAt ;counter <= this.pagesAvailable; counter++){
                    const skipCount = (this.pageSize*counter)-this.pageSize
                    pagerRenderData.push({
                        type: 'page',
                        displayNumber: counter,
                        current: (this.currentlyViewingPage===counter),
                        clickHandler: ()=>{
                            this.navigateToPage(skipCount)
                        }
                    })
                }
            }

            return pagerRenderData
        }
    },
    methods: {
        navigateToPage(skipCount){
            this.$store.commit('search/setSearchConfig',{
                skip: skipCount
            })
            this.$store.dispatch('search/performSearch').then(()=>{
                this.setFocus()
                this.scrollToPager()
            })   
        },
        scrollToPager(){
            const scrollThePage = !(this.receivesFocus)
            if(scrollThePage){
                const elemInFocus = document.activeElement
                const scrollTargetPosY = getPositionCoords(elemInFocus).y;
                const posYPadding = 95
                const posY = scrollTargetPosY - posYPadding
                const posX = 0
                window.scrollTo(posX,posY)
            } 
        },
        setFocus(){
            const pagerElemToReceiveFocus = this.$parent.$refs.mainFilterPager.$refs.activepage[0]
            pagerElemToReceiveFocus.focus() 
        }
    }
}